export const romanNumeralQualitySuffixes = ['#', 'b', 'o', '+', 'o/'] as const;
export type RomanNumeralQualitySuffix = typeof romanNumeralQualitySuffixes[number];

export const romanNumeralRootAlterationPrefixes = ['#', 'b'] as const;
export type RomanNumeralRootalAlterationPrefix = typeof romanNumeralRootAlterationPrefixes[number];

export const romanQualities = {
  Major: {
    // triad, sevent
    1: ['I', 'I'],
    2: ['ii', 'ii'],
    3: ['iii', 'iii'],
    4: ['IV', 'IV'],
    5: ['V', 'V'],
    6: ['vi', 'vi'],
    7: ['viio', 'viio/'],
  },
  minor: {
    1: ['i', 'i'],
    2: ['iio', 'iio/'],
    3: ['III', 'III'],
    4: ['iv', 'iv'],
    5: ['V', 'V'],
    6: ['VI', 'VI'],
    b7: ['VII', 'VII'],
    7: ['viio', 'viio'],
  },
  MajorChordQualities: {
    1: ['Maj', 'Maj7'],
    2: ['min', 'min7'],
    3: ['min', 'min7'],
    4: ['Maj', 'Maj7'],
    5: ['Maj', 'Dom7'],
    6: ['min', 'min7'],
    7: ['dim', 'o/7'],
  },
  minorChordQualities: {
    1: ['min', 'min7'],
    2: ['dim', 'o/7'],
    3: ['Maj', 'Maj7'],
    4: ['min', 'min7'],
    5: ['Maj', 'Dom7'],
    6: ['Maj', 'Maj7'],
    b7: ['Maj', 'Dom7'],
    7: ['dim', 'dim7'],
  },
};

export const validRomans = {
  // sd: [ [triadQual, seventhQual], [triadInversions], [seventhInversions] ],
  Major: {
    1: [['Maj', false], [0, 1], []],
    2: [
      ['min', 'min7'],
      [0, 1, 2],
      [0, 1, 3],
    ],
    3: [['min', 'min7'], [0], [0]],
    4: [
      ['Maj', 'Maj7'],
      [0, 1, 2],
      [0, 1],
    ],
    5: [
      ['Maj', 'Dom7'],
      [0, 1],
      [0, 1, 2, 3],
    ],
    6: [
      ['min', 'min7'],
      [0, 1],
      [0, 1, 3],
    ],
    7: [['o', 'o/7'], [1], [0, 1, 2]],
  },
  minor: {
    // rn: [ [triadQual, seventhQual], [triadInversions], [seventhInversions] ],
    1: [['min', false], [0, 1], []],
    2: [
      ['o', 'o/'],
      [0, 1],
      [0, 1, 2, 3],
    ],
    3: [['Maj', false], [0], []],
    4: [
      ['min', 'min7'],
      [0, 1],
      [0, 1, 2, 3],
    ],
    5: [
      ['Maj', 'Dom7'],
      [0, 1],
      [0, 1, 2, 3],
    ],
    6: [
      ['Maj', 'Maj7'],
      [0, 1],
      [0, 1],
    ],
    M7: [['o', 'o7'], [1], [0, 1, 2]],
  },
};

export function toRoman(scaleDegree: string) {
  let accidental = `${scaleDegree}`.charAt(0);
  let num = Number(scaleDegree[0]);
  if (accidental < '0' || accidental > '9') {
    num = Number(scaleDegree.slice(1));
  } else {
    accidental = '';
  }
  const sd = ['', 'i', 'ii', 'iii', 'iv', 'v', 'vi', 'vii'][num];
  return accidental + sd;
}

export function romanToInt(roman: string) {
  let numeralOnly = roman;
  let accidental = '';
  if (roman.charAt(0) === '#' || roman.charAt(0) === 'b') {
    numeralOnly = roman.slice(1);
    accidental = roman.slice(0, 1);
  }
  if (numeralOnly === 'viio' || numeralOnly === 'iio') {
    numeralOnly = numeralOnly.slice(0, -1);
  }

  if (numeralOnly === 'viio/' || numeralOnly === 'iio/') {
    numeralOnly = numeralOnly.slice(0, -2);
  }

  const rn = ['', 'i', 'ii', 'iii', 'iv', 'v', 'vi', 'vii'];
  const i = rn.indexOf(numeralOnly.toLowerCase());
  if (i === -1) return false;
  return accidental === '' ? i : accidental + i;
}
